export default __webpack_public_path__ + "static/media/image.newtronix-innovations-pvt-ltd.649b0ae9.png";